import React from 'react'
import LoadMaps from '../components/LoadMaps'

const Home = () => {
  return (
    <div>
    <h1>Home</h1>
    <LoadMaps/>
    {/* Complete profile including group and contact 
      homepage asks location confirmation   --done
      nearby page shows available options
      can check for availability of groups and quantity
      request for rare groups
      membership plans and payment
      profile page
    */}

    </div>
  )
}

export default Home